import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import CommissionPointsAndPrice from '../../../../../CommissionPointsAndPrice';
import s from './PriceBlock.scss';
const PriceBlock = ({ priceTextClassName , price , priceLabel , priceLabelOnTop , dollarsCost  })=>{
    const { t  } = useTranslation();
    return dollarsCost !== undefined ? /*#__PURE__*/ React.createElement("div", {
        className: s['price-wrapper']
    }, /*#__PURE__*/ React.createElement(CommissionPointsAndPrice, {
        points: price,
        price: dollarsCost,
        dollarsClassName: s['price-dollars'],
        pointsClassName: s['price-points']
    })) : /*#__PURE__*/ React.createElement(Flex, {
        justifyContent: priceLabelOnTop ? 'flex-end' : 'center',
        direction: priceLabelOnTop ? 'column-reverse' : 'column',
        className: classnames(s['price'], priceLabelOnTop && s['price-on-top'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['price-value'], priceTextClassName)
    }, price), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['price-label'], priceTextClassName)
    }, t(priceLabel)));
};
PriceBlock.displayName = 'PriceBlock';
export default PriceBlock;
